import React from 'react';
import Icon from '@amzn/awsui-components-react/polaris/icon';
import WarningIcon from './WarningIcon';
import { IconVariant } from '../types';

export type { IconVariant };

interface AttributeRowProps {
  label: string;
  value: string | undefined;
  isValid: boolean;
  warningMessage: string;
  warningVariant: IconVariant;
  fallback?: string;
}

const AttributeRow: React.FC<AttributeRowProps> = ({
  label,
  value,
  isValid,
  warningMessage,
  warningVariant,
  fallback,
}) => (
  <p>
    {isValid ? (
      <Icon name="status-positive" variant="success" />
    ) : (
      <WarningIcon message={warningMessage} variantType={warningVariant} />
    )}{' '}
    {label}:&nbsp;{value || fallback}
  </p>
);

export default AttributeRow;
